import { createSlice } from '@reduxjs/toolkit';
import { ITeamManagement } from './TeamManagement.type';

export interface TeamManagementState {
  isUpdateListTeam: boolean;
  isEditListTeam: boolean;
  isUpdateTeamUser: boolean;
  currentSelectedProject: any;
  teamDeatil: Partial<ITeamManagement>;
}

const initialState: TeamManagementState = {
  isUpdateListTeam: false,
  isEditListTeam: false,
  isUpdateTeamUser: false,
  currentSelectedProject: null,
  teamDeatil: {},
};

export const teamManagementSlice = createSlice({
  name: 'TeamManagement',
  initialState,
  reducers: {
    triggerIsUpdateListTeam: state => {
      state.isUpdateListTeam = !state.isUpdateListTeam;
    },
    triggerIsEditListTeam: state => {
      state.isEditListTeam = !state.isEditListTeam;
    },
    triggerIsUpdateTeamUser: state => {
      state.isUpdateTeamUser = !state.isUpdateTeamUser;
    },
    setTeamDeatil: (state, action) => {
      state.teamDeatil = action.payload;
    },
  },
  extraReducers: builder => {},
});

export const { triggerIsEditListTeam, triggerIsUpdateListTeam, setTeamDeatil, triggerIsUpdateTeamUser } =
  teamManagementSlice.actions;
export default teamManagementSlice.reducer;
